var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{on:{"click":function($event){_vm.isOpen = true}}},[_vm._t("default")],2),_c('nl-modal',{attrs:{"open-modal":_vm.isOpen,"title":_vm.title},on:{"hidden":function($event){_vm.isOpen = false}}},[_c('iframe',{staticClass:"w-100",staticStyle:{"min-height":"75vh"},attrs:{"srcdoc":_vm.html}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }